import { launchModal } from '../../client/modal/service';
import Modal from './modal.vue';

export const launchSettingsModal = async () => {
  return launchModal({
    component: Modal,
    props: {},
  });
};
